const LGSerialPortCommunicationHandler = require("./LGSerialPortCommunicationHandler");

const service = {};

service.getSerialPortCommunicationHandler = () => {
  return LGSerialPortCommunicationHandler; // For now, only LG is supported
};

module.exports = service;
